import { render, staticRenderFns } from "./ListReception.vue?vue&type=template&id=54ce1386&scoped=true&"
import script from "./ListReception.vue?vue&type=script&lang=js&"
export * from "./ListReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce1386",
  null
  
)

export default component.exports